import TextLoadingBox from 'components/Luxkit/Typography/TextLoadingBox'
import ListItem from 'components/Luxkit/List/ListItem'
import React, { ComponentProps, ReactNode } from 'react'
import IconLoadingBox from '../Icons/IconLoadingBox'

type TextLoadingBoxWidth = ComponentProps<typeof TextLoadingBox>['width']

interface Props extends Pick<ComponentProps<typeof ListItem>, 'size'> {
  overline?: true | ReactNode
  overlineWidth?: TextLoadingBoxWidth
  title?: ReactNode
  titleWidth?: TextLoadingBoxWidth
  subtitle?: true | ReactNode
  subtitleWidth?: TextLoadingBoxWidth
  startIcon?: true | ReactNode
  endIcon?: true | ReactNode
}

function ListItemLoadingSkeleton(props: Props) {
  const {
    overline,
    overlineWidth = '20%',
    title,
    titleWidth = '40%',
    subtitle,
    subtitleWidth = '50%',
    endIcon,
    startIcon,
    size,
  } = props

  return <ListItem
    size={size}
    overline={overline === true ? <TextLoadingBox width={overlineWidth} /> : overline}
    title={title || <TextLoadingBox width={titleWidth} />}
    subtitle={subtitle === true ? <TextLoadingBox width={subtitleWidth} /> : subtitle}
    startIcon={startIcon === true ? <IconLoadingBox /> : startIcon}
    endIcon={endIcon === true ? <IconLoadingBox /> : endIcon}
    nonInteractable
  />
}

export default ListItemLoadingSkeleton
